import React from 'react';

interface Proptypes {
  className?: string;
  onClick?: () => void;
}

const ZoomIn = ({ className, onClick }: Proptypes) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ''}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.5C0 11.6421 3.35786 15 7.5 15C9.23164 15 10.8262 14.4131 12.0957 13.4275C12.1435 13.5286 12.2092 13.6234 12.2929 13.7071L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.7071 12.2929C13.6234 12.2092 13.5286 12.1435 13.4275 12.0957C14.4131 10.8262 15 9.23164 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5ZM2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5ZM6.5 5C6.5 4.44772 6.94772 4 7.5 4C8.05229 4 8.5 4.44772 8.5 5V6.5H10C10.5523 6.5 11 6.94772 11 7.5C11 8.05228 10.5523 8.5 10 8.5H8.5V10C8.5 10.5523 8.05229 11 7.5 11C6.94772 11 6.5 10.5523 6.5 10V8.5H5C4.44772 8.5 4 8.05228 4 7.5C4 6.94772 4.44772 6.5 5 6.5H6.5V5Z"
        fill="black"
      />
    </svg>
  );
};

export default ZoomIn;
